// Extracted voice agent page wrappers to stay under 300-line file limit
import { AppLayoutMemo } from '@/components/layout';
import { VoiceAgentsListPage } from '@/pages/insurance/VoiceAgentsListPage';
import { VoiceCallHistoryPage } from '@/pages/insurance/VoiceCallHistoryPage';
import { VoiceCallDetailPage } from '@/pages/insurance/VoiceCallDetailPage';
import { VoicePhoneNumbersPage } from '@/pages/insurance/VoicePhoneNumbersPage';
import { VoiceSipTrunksPage } from '@/pages/insurance/VoiceSipTrunksPage';

export function VoiceAgentsListPageWrapper() {
  return (
    <AppLayoutMemo>
      <VoiceAgentsListPage />
    </AppLayoutMemo>
  );
}

export function VoiceCallHistoryPageWrapper() {
  return (
    <AppLayoutMemo>
      <VoiceCallHistoryPage />
    </AppLayoutMemo>
  );
}

export function VoiceCallDetailPageWrapper() {
  return (
    <AppLayoutMemo>
      <VoiceCallDetailPage />
    </AppLayoutMemo>
  );
}

export function VoicePhoneNumbersPageWrapper() {
  return (
    <AppLayoutMemo>
      <VoicePhoneNumbersPage />
    </AppLayoutMemo>
  );
}

export function VoiceSipTrunksPageWrapper() {
  return (
    <AppLayoutMemo>
      <VoiceSipTrunksPage />
    </AppLayoutMemo>
  );
}
